// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactTopicEntity from './entities/contact-topic.json';
import contactTopicMenu from '../pages/contact-topic/menu.json';
import contactTopicFullForm from '../pages/contact-topic/forms/full.json';
import contactTopicContextForm from '../pages/contact-topic/forms/context.json';
import contactTopicMiniForm from '../pages/contact-topic/forms/mini.json';
import contactTopicLookupForm from '../pages/contact-topic/forms/lookup.json';
import contactTopicTableView from '../pages/contact-topic/views/table.json';
import contactTopicDashboardView from '../pages/contact-topic/views/dashboard.json';

/** Тип запису «Тема контакту» зі сторінками пакета: меню, форми та подання з pages/contact-topic/. */
export const contactTopicDefinition: IRecordTypeDefinition = {
  ...contactTopicEntity,
  views: assembleViewSet({
      table: contactTopicTableView,
      dashboard: contactTopicDashboardView,
  }),
  form: contactTopicFullForm,
  forms: { full: contactTopicFullForm, context: contactTopicContextForm, mini: contactTopicMiniForm, lookup: contactTopicLookupForm },
  menu: contactTopicMenu,
} as IRecordTypeDefinition;
